// @flow

import React from "react";
import { connect } from "react-redux";
import { localize } from "redux-i18n";
import { compose } from "redux";
import { SectionComponent, Button } from "@components";
import type { DocumentType } from "@modules/shared/reducer/employee-events/types";
import actionCreators from "@modules/shared/actionCreator";
import * as selectors from "@modules/shared/selectors/employee-events";
import type { State } from "@store/reducers";
import { DocumentsList, AddDocumentModal } from "@modules/shared/components";
import { parseSchema } from "@utils/schema";
import { unpatch } from "@transformers/js-client";

type OwnProps = $Exact<{
  employeeId: number,
  clientId: number,
}>;

type PropsFromState = $Exact<{
  documents: Array<DocumentType>,
  isAddDocumentModalOpen: boolean,
}>;

type PropsFromDispatch = $Exact<{
  getDocuments: typeof actionCreators.GetEmployeeDocuments,
  onAddDocumentHandler: Function,
  onDismissAddDocumentHandler: Function,
  addDocument: typeof actionCreators.AddEmployeeDocument,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromState,
  ...PropsFromDispatch,
  ...PropsFromLocalize,
}>;

type ComponentState = $Exact<{
  schema: ?Object,
  disableAddButton: boolean,
}>;

export class Documents extends React.Component<Props, ComponentState> {
  state = {
    schema: null,
    disableAddButton: false,
  };

  componentDidMount() {
    this.props.getDocuments({
      clientId: this.props.clientId,
      employeeId: this.props.employeeId,
    });

    if (!this.state.schema) {
      parseSchema("EmployeeFileDTO").then(schema =>
        this.setState({
          schema,
        }),
      );
    }
  }

  addDocument = (formData: Object) => {
    this.setState({
      disableAddButton: true,
    }),
      this.props.addDocument({
        formData: unpatch(formData),
        clientId: this.props.clientId,
        employeeId: this.props.employeeId,
      });
  };

  addDocumentHandler = () => {
    this.props.onAddDocumentHandler();
    this.setState({
      disableAddButton: false,
    });
  };

  render() {
    return (
      <SectionComponent
        wrapperClassName="flex-column"
        title={<h5>{this.props.t("DOCUMENTS")}</h5>}
        rightLink={
          <Button materialIcon="upload_file" onClick={this.addDocumentHandler}>
            {this.props.t("UPLOAD")}
          </Button>
        }
      >
        {this.state.schema && this.props.isAddDocumentModalOpen && (
          <AddDocumentModal
            onDismissHandler={this.props.onDismissAddDocumentHandler}
            onSubmit={this.addDocument}
            schema={this.state.schema}
            disabledButton={this.state.disableAddButton}
          />
        )}
        <DocumentsList
          data={this.props.documents}
          employeeId={this.props.employeeId}
          clientId={this.props.clientId}
        />
      </SectionComponent>
    );
  }
}

const mapStateToProps = (state: State): PropsFromState => ({
  documents: selectors.getDocuments(state),
  isAddDocumentModalOpen: selectors.getIsAddDocumentModalOpen(state),
});

const mapDispatchToProps: PropsFromDispatch = {
  getDocuments: actionCreators.GetEmployeeDocuments,
  onAddDocumentHandler: () => actionCreators.ToggleAddEmployeeDocumentModal(true),
  onDismissAddDocumentHandler: () => actionCreators.ToggleAddEmployeeDocumentModal(false),
  addDocument: actionCreators.AddEmployeeDocument,
};

export default compose(connect(mapStateToProps, mapDispatchToProps), localize())(Documents);
